<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">상품 관리</a> &gt; <strong>청첩장 리스트</strong></div>
			<h2 class="h_sub">청첩장 리스트</h2>
		</div>

    <InvitationWeddingListForm/>
  </div>
</template>

<script>
import InvitationWeddingListForm from '@/components/admin/product/InvitationWeddingListForm.vue';

export default {
  components: {
    InvitationWeddingListForm
  }    
}
</script>
<style lang="">
    
</style>